import { IAuthTokenBuilder } from 'fitbeat.api-clients';
import { LogoutHelper } from '../utils';
import auth from '@react-native-firebase/auth';
export class AuthTokenBuilder implements IAuthTokenBuilder {
  getAuthorizationHeader = async () : Promise<string> => {
    const accessToken = await this.getAccessToken(false);
    return `Bearer ${accessToken}`;
  }

  forceRefreshAndGetAuthorizationHeader = async () : Promise<string> => {
    const accessToken = await this.getAccessToken(true);
    return `Bearer ${accessToken}`;
  }

  getAccessToken = async (forceRefresh) : Promise<string> => {
    const user = auth().currentUser;
    if (user) {
      return await user.getIdToken(forceRefresh);
    }
    return LogoutHelper();
  }
}
